// `--vvh` on <html>: the visual viewport height, so a phone sheet shrinks above the on-screen
// keyboard (windows.css reads it; the `100dvh` fallback stands where the API is missing).
export function installVvh() {
  const vv = window.visualViewport;
  if (!vv) return;
  const set = () => document.documentElement.style.setProperty('--vvh', `${Math.round(vv.height)}px`);
  vv.addEventListener('resize', set);
  set();
}
